<template>
    <popup-modal ref="popup">

        <h2 class="font-bold mb-4 text-xl">Распубликовать пост?</h2>

        <div class="mb-4">Укажите причину распубликации</div>

        <textarea v-model="form.reason"
                  ref="reason"
                  class="w-full h-20 input mb-4 focus:outline-none bg-white/10"
                  autofocus></textarea>

        <div v-if="isModerator" class="space-y-2 mb-4">
            <label class="flex items-center space-x-1 p-2 rounded cursor-pointer bg-red-200/50">
                <input type="checkbox" v-model="form.republish_forbidden">
                <span>Запретить повторную публикацию</span>
            </label>
        </div>

        <div class="flex items-center justify-between">
            <button class="btn btn-md" @click.prevent="_cancel">Отмена</button>
            <button class="btn btn-md btn-primary" @click.prevent="_confirm">Распубликовать</button>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from './PopupModal.vue'
import Textarea from "../form/textarea";
import User from "../../js/modules/User";

export default {
    components: {Textarea, PopupModal},

    data() {
        let user = new User();
        let userData = user.data();

        return {
            isModerator: userData?.can_moderate ?? false,
            resolvePromise: undefined,
            rejectPromise: undefined,
            form: {
                reason: '',
                republish_forbidden: false,
            }
        }
    },

    methods: {
        show(opts = {}) {
            this.$refs.popup.open();

            setTimeout(() => {
                this.$refs.reason.focus();
            }, 100);

            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve;
                this.rejectPromise = reject;
            })
        },

        _confirm() {
            this.$refs.popup.close();

            let data = {
                reason: this.form.reason,
            }

            if (this.isModerator) {
                data.republish_status = this.form.republish_forbidden;
            }

            this.resolvePromise(data);
        },

        _cancel() {
            this.$refs.popup.close();
            this.rejectPromise();
        },
    },
}
</script>